import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

export function HintContainer(props) {
  return (
    <div className="ps_hintContainer">
      <div className="ps_hintContainer_alignmentTop" />
      <div className="ps_hintContainer_alignmentRight" />
      <div className="ps_hintContainer_alignmentBottom" />
      <div className="ps_hintContainer_alignmentLeft" />
      <div className="ps_hintContainer_bottomPadding" />
      {props.children}
    </div>
  );
}

HintContainer.propTypes = {
  /**
   * chilkd components passed
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

HintContainer.defaultProps = {};
